import type { PostInputMetaData } from '../../graphqlTypes'
import type { Draft } from '~publish/legacy/composer/composer/entities/Draft'

import { getChannelVariantLinkAttachment } from '../../channelVariantToCreatePostInput'
import { mapLinkAttachment } from '../../mapAssets'
import type { MapperContext } from '../../types'
import { getLinkedInAnnotations } from '../shared/annotations'
import { clearable } from '../shared/clearable'
import { getFirstComment } from '../shared/firstComment'
import type { ServiceMapperEntry } from '../types'

// LinkedIn: first comment, mention annotations, and the link attachment, each
// tri-stated via `clearable` so an edit that clears them sends an explicit
// `null`. Unlike the output `LinkedInPostMetadata` type, the input has no
// `type` field — the post/carousel distinction travels entirely through the
// attached document (`mapAssets`'s document branch and its title), not
// metadata.
//
// `ctx.channelVariant` (when present) supplies first comment and the link
// attachment. Mention annotations still read the editor (`ctx.editor` when
// `composer-zustand-editor-state` is on, else `draft.editorState`) — rich
// Slate editor state, not something `ChannelVariant` models.
export function mapLinkedin(
  draft: Draft,
  ctx: MapperContext,
): PostInputMetaData {
  const variant = ctx.channelVariant
  const firstComment = clearable(
    variant
      ? variant.channelData?.linkedin?.comment_text || undefined
      : getFirstComment(draft),
    ctx,
  )
  const annotations = clearable(getLinkedInAnnotations(draft, ctx), ctx)
  const linkAttachment = clearable(
    variant
      ? getChannelVariantLinkAttachment(variant)
      : mapLinkAttachment(draft),
    ctx,
  )

  return {
    linkedin: {
      ...(firstComment !== undefined ? { firstComment } : {}),
      ...(annotations !== undefined ? { annotations } : {}),
      ...(linkAttachment !== undefined ? { linkAttachment } : {}),
    },
  }
}

export const linkedin: ServiceMapperEntry = {
  mapper: mapLinkedin,
}
